import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const LogoutButton = () => {
  const navigate = useNavigate();
  const {logout, isLoggingOut} = useContext(UserContext);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      navigate('/login');
    }
  };

  return (
    <button onClick={handleLogout} className="logout-btn" disabled={isLoggingOut} aria-busy={isLoggingOut}>
      {isLoggingOut ? 'Cerrando' : 'Salir'}
    </button>
  );
};

export default LogoutButton;
